import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  Pipe,
  PipeTransform,
  SimpleChanges,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { map, startWith, tap } from 'rxjs/operators';
import { MagnifyFieldSearchComponent } from 'src/app/shared/components/magnify-field-search/magnify-field-search.component';
import { DataService } from 'src/app/services/data.service';
import { CommonService } from 'src/app/services/common.service';

export interface OptionData {
  name: string;
  id: string;
}

@Component({
  selector: 'app-autocomplete',
  templateUrl: './autocomplete.component.html',
  styleUrls: ['./autocomplete.component.css']
})
export class AutocompleteComponent implements OnInit, AfterViewInit, OnChanges {
  filteredOptions: Observable<OptionData[]>;
  @Input() frmGlobal: FormGroup;
  @Input() field: any = { is_magnify_search: 1, field_mapping_detail_id: 0 };

  @Input() defaultValue: any;

  myControl = new FormControl();

  options: any = [];
  @Output() callOnAutoCompleteChangedEvent = new EventEmitter<any>();

  constructor(private modalService: NgbModal, private dataService: DataService, private commonService: CommonService) { }
  ngOnChanges(): void {
  }


  ngAfterViewInit(): void {
    setTimeout(() => {

      if (this.field.is_readonly == 1 || this.field.is_editable == 0) {
        this.myControl.disable();
      }
      else {
        this.myControl.enable();
      }

      let optionFilteredData = [];
      if (this.field.options != undefined) {
        optionFilteredData = this.field.options.filter(
          (o) => o.id == this.field.field_value
        );
      }
      if (optionFilteredData != undefined && optionFilteredData.length > 0) {
        this.filteredOptions = this.myControl.valueChanges.pipe(
          startWith(optionFilteredData[0].name),
          map((value) => (typeof value === 'string' ? value : value.name)),
          map((name) => (name ? this._filter(name) : [])),
          tap(() => this.myControl.setValue(optionFilteredData[0]))
        );
      }
    }, 2000);
  }

  ngOnInit(): void {

    this.options = this.field.options;
    let fieldValidators = [];
    if (this.field.is_mandatory == 1) {
      fieldValidators = [Validators.required];
    }



    let filteredValue = '';
    this.myControl = new FormControl(filteredValue, fieldValidators);
    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(''),
      map((value) => (typeof value === 'string' ? value : value.name)),
      map((name) =>
        name
          ? this._filter(name)
          : this.field.field_value != null
            ? this.field.options
            : []
      )
    );
  }

  displayFn(user?: OptionData): string | undefined {
    return user ? user.name : undefined;
  }
  returnFn(user?: OptionData): string | undefined {
    return user ? user.name : undefined;
  }

  private _filter(name: string): OptionData[] {

    const filterValue = name.toLowerCase();
    if (filterValue.length >= 3) {
      return this.getAutocomplete_dropdowndata(this.field.field_mapping_detail_id, filterValue);
      // by prakash
      // return this.field.options.filter(
      // (option) => option.name.toLowerCase().indexOf(filterValue) === 0
      //);
    }
    this.field.options = [];
    return [];
  }

  openAdvanceSearchModal(
    fieldMappingDetailId: number,
    predefinedTableColumnName: string = 'id'
  ) {
    const modalRef = this.modalService.open(MagnifyFieldSearchComponent, {
      size: 'xl',
      centered: true,
      backdrop: 'static',
      keyboard: false,
    });
    modalRef.componentInstance.fieldMappingDetailId = fieldMappingDetailId;
    modalRef.componentInstance.predefinedTableColumnName =
      predefinedTableColumnName;
    modalRef.componentInstance.selectRecord.subscribe(async (res) => {
      this.field.options = await this.commonService.getAutocomplete_dropdowndata(res.fieldId, res.fieldValue, 'id');
      let optionDataValue = this.field.options.filter(
        (item) => item.id == res.fieldValue
      );
      this.field.fieldValue = res.fieldValue;

      if (optionDataValue.length > 0) {
        this.filteredOptions = this.myControl.valueChanges.pipe(
          startWith(optionDataValue[0].name),
          map((value) => (typeof value === 'string' ? value : value.name)),
          map((name) => (name ? this._filter(name) : [])),
          tap(() => this.myControl.setValue(optionDataValue[0]))
        );
      }
      this.OnAutoCompleteChangedEvent();
      modalRef.close();
    });
    modalRef.componentInstance.closeModal.subscribe(() => {
      modalRef.close();
    });
  }

  get f() {
    return this.myControl;
  }

  OnAutoCompleteChangedEvent() {
    this.callOnAutoCompleteChangedEvent.emit(this.field);
  }

  onOptionSelected(value: any) {
    this.field.fieldValue = value.id;
    this.OnAutoCompleteChangedEvent();
  }
  onSelectionChange(event) {

    let value = event.target.value;
    if (value == '' || value == undefined) {
      this.filteredOptions = this.myControl.valueChanges.pipe(
        startWith(''),
        map((value) => (typeof value === 'string' ? value : value.name)),
        map((name) => (name ? this._filter(name) : []))
      );
      this.field.fieldValue = 0;
      this.OnAutoCompleteChangedEvent();
    }
  }

  getAutocomplete_dropdowndata(fieldMappingDetailId, searchkeyword) {

    let params = {
      field_mapping_detail_id: fieldMappingDetailId,
      keyword: searchkeyword.toString(),
      dependent_parameter: this.field.dropdown_dependant_parameter
    };
    this.dataService.postData('dropdown_autocomplete', params).subscribe((res) => {
      if (res != null && res != undefined) {
        this.field.options = res.data;
        return this.field.options;
      }
    });
    return this.field.options;
  }

  ocrFocus(field) {
    if (field.is_ocr) {
      field.confidence_level = 0;
      field.ocr_confidence_level_cssclass = 'ocr-blue';
    }
  }

  omit_special_char(e, regExp) {
    // var k;
    // k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    // return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
    
    //var regex = new RegExp("^[a-zA-Z0-9 ]+$");
    if (regExp == "" || regExp == null || regExp == undefined)
      return true;

    var regex = new RegExp(regExp);
    var str = String.fromCharCode(!e.charCode ? e.which : e.charCode);
    if (regex.test(str)) {
      return true;
    }

    e.preventDefault();
    return false;
  }

  omit_onPaste(e) {
    ///(paste)="onPaste($event)" add this line into html input.
    e.preventDefault();
    return false;
  }
}
